module.exports = __webpack_public_path__ + "static/media/sp-logo.46e39842.svg";